// extracted by mini-css-extract-plugin
export default {"songs":"songs_songs__KlXvb","mobilePagination":"songs_mobilePagination__0Pwj+","pagination":"songs_pagination__QVjD4","table":"songs_table__37lY9"};